import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/board'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'GENERAL_SETTINGS.BOARD.TITLE',
        icon: 'pipeline',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'board',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
